import supabase from './supabase';

function getAnonId() {
  let anonId = localStorage.getItem('anon_id');
  if (!anonId) {
    anonId = crypto.randomUUID();
    localStorage.setItem('anon_id', anonId);
  }
  return anonId;
}

/**
 * Log an event when a user navigates to the show details page.
 * @param {String|null} userId - The user's ID if logged in.
 * @param {String} showId - The show's ID.
 * @param {String} source - The page show details is clicked from.
 * @returns {Promise<void>}
 */
export async function logShowDetailsClickEvent(userId, showId, source) {
  let anonId = getAnonId();

  const { error } = await supabase.from('show_views').insert([
    {
      user_id: userId ?? null,
      anon_id: anonId,
      show_id: Number(showId),
      source: source,
      platform: 'web',
    },
  ]);

  if (error) {
    console.error('Error saving show:', error);
    throw error;
  }
}

/**
 * Log a batch of show impressions.
 * @param {(number|string)[]} showIds
 * @param {'feed'|'map'|'list'} source
 * @returns {Promise<boolean>}
 */
export async function logShowImpression(showIds, source) {
  if (!showIds || showIds.length === 0) return true;

  try {
    const { error } = await supabase.rpc('log_show_impression', {
      p_show_ids: showIds.map(Number),
      p_platform: 'web',
      p_source: source,
    });

    if (error) {
      console.error('Error logging show impression:', error);
      return false;
    }
    return true;
  } catch (error) {
    console.error('Error logging show impression:', error);
    return false;
  }
}
